/**
 * Predefined Table columns enum.
 * These values are supposed to be used when preparing table data and columns.
 */
export enum Columns {
    ID = 'Lead_ID',
    NEW = 'Is_New',
    NAME = 'Name',
    WORTH = 'Estimated_Net_Worth',
    CITY = 'City',
    STATE = 'State',
    CATALYST = 'Catalyst',
    PHONE = 'Phone',
    EMAIL = 'Email',
    SOCIAL = 'Social_Links',
    DATE_ADDED = 'Date_Added',
    DATE_CONTACTED = 'Date_Contacted',
    DATE_RESPONDED = 'Date_Responded',
    DATE_CLOSED = 'Date_Closed',
    DATE_UPDATED = 'Date_Updated',
}

export enum HiddenColumns {
    ADDRESS = 'Address',
    FIRST_NAME = 'First Name',
    LAST_NAME = 'Last Name',
    AGE = 'Age',
}

// IDS used for sortin
export enum ColumnsSortId {
    NAME = 'firstName',
    WORTH = 'netWorth',
    CITY = 'city',
    STATE = 'state',
    CATALYST = 'categories',
    DATE_ADDED = 'created',
    DATE_UPDATED = 'updated',
}
